export default {
  institutions: null,
  banks: null,
  transporters: null
}
